import { Bar } from "react-chartjs-2";
import "chart.js/auto";
import { getColorByValue } from "../../../helpers/utils";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { useTranslation } from "react-i18next";
import { ChartData, ChartOptions } from "chart.js/auto";
import { forwardRef } from "react";
import { ChartJSOrUndefined } from "react-chartjs-2/dist/types";

type OverallComparisonBarChartProps = {
  height: string;
  data1: any;
  data2: any;
  pc1: string;
  pc2: string;
  attribute: string;
  selectAll?: boolean;
  onRendered?: () => void;
};

const OverallComparisonBarChart = forwardRef<
 ChartJSOrUndefined<"bar", (number | [number, number] | null)[], unknown>,
  OverallComparisonBarChartProps
>(
  (
    { height, data1, data2, pc1, pc2, attribute, onRendered, selectAll },
    ref
  ) => {
    const { t } = useTranslation();
    const mli1 = data1 && data1.mli ? data1.mli : 0;
    const pain1 = data1 && data1.pain ? data1.pain : 0;
    const mli2 = data2 && data2.mli ? data2.mli : 0;
    const pain2 = data2 && data2.pain ? data2.pain : 0;
    let projectCode1 = data1 === undefined ? t("unavailable") : pc1;
    let projectCode2 = data2 === undefined ? t("unavailable") : pc2;
    if (projectCode1 === projectCode2) {
      projectCode1 = projectCode1 + " (1)";
      projectCode2 = projectCode2 + " (2)";
    }

    const data: ChartData<"bar"> = {
      labels: ["MLI", t("pain")],
      datasets: [
        {
          label: projectCode1,
          data: [mli1, pain1],
          backgroundColor: [
            getColorByValue(mli1, "MLI", attribute === "MLI", selectAll),
            getColorByValue(pain1, "pain", attribute === t("pain"), selectAll),
          ],
          stack: "Stack 0",
        },
        {
          label: projectCode2,
          data: [mli2, pain2],
          backgroundColor: [
            getColorByValue(mli2, "MLI", attribute === "MLI", selectAll),
            getColorByValue(pain2, "pain", attribute === t("pain"), selectAll),
          ],
          stack: "Stack 1",
        },
      ],
    };

    const options: ChartOptions<"bar"> = {
      maintainAspectRatio: false,
      plugins: {
        title: {
          display: true,
          text: `   ${t("mli-pain-comp")}`,
          align: "start",
          padding: {
            top: 5,
            bottom: 15,
          },
        },
        legend: {
          display: false,
        },

        datalabels: {
          display: true,
          anchor: "end",
          align: "end",
          font: {
            weight: "bold",
          },

          formatter: (_: any, context: any) =>
            context.chart.data.datasets[context.datasetIndex].label,
        },
      },
      animation: {
        onComplete: () => {
          if (typeof onRendered === "function") {
            onRendered();
          }
        },
      },
      scales: {
        x: {
          stacked: true,
        },
        y: {
          stacked: true,
          beginAtZero: true,
          max: 10,
        },
      },
    };

    return (
      <div
        style={{
          height: height,
          width: "99%",
        }}
      >
        <Bar ref={ref} plugins={[ChartDataLabels]} data={data} options={options} />
      </div>
    );
  }
);

export default OverallComparisonBarChart;
